module.exports = __webpack_public_path__ + "static/UJECIE1v4-2850efa73bac4ec5d10a4b2f89c9496a.jpg";